import { IResponseProps } from '@/entities/Response'
import { IOrderProps } from '@/entities/Order'

export const Types = {
  store: 'store',
  current: 'current',
  year: 'year',
  method: 'method'
}

export const path = 'order/'

export class Store implements FluxStandardAction<IResponseProps<IOrderProps>> {
  type = path + Types.store
  constructor(public payload: IResponseProps<IOrderProps>) {}
}

export class Current implements FluxStandardAction<IOrderProps | null> {
  type = path + Types.current
  constructor(public payload: IOrderProps | null) {}
}

export class Year implements FluxStandardAction<number> {
  type = path + Types.year
  constructor(public payload: number) {}
}
export class Method implements FluxStandardAction<string | null> {
  type = path + Types.method
  constructor(public payload: string | null) {}
}
